const htmlElement = document.querySelector( "html" );
htmlElement.classList.add( "js" );
htmlElement.classList.remove( "no-js" );

const seeResults = document.getElementById( "see-results" );
new Waypoint( {
  element: seeResults,
  offset: "90%",
  handler () {
    seeResults.classList.add( "animated" );
  },
} );

const viewReport = document.getElementById( "view-report" );
new Waypoint( {
  element: viewReport,
  offset: "70%",
  handler () {
    viewReport.classList.add( "animated" );
  },
} );

const keyFindings = document.getElementById( "key-findings" );
new Waypoint( {
  element: keyFindings,
  offset: "70%",
  handler () {
    keyFindings.classList.add( "animated" );
  },
} );

const yourMat = document.getElementById( "your-mat" );
new Waypoint( {
  element: yourMat,
  offset: "70%",
  handler () {
    yourMat.classList.add( "animated" );
  },
} );

new LazyLoad( {
  elements_selector: ".lazy",
} );
